import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import localForage from "localforage";
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InsertDriveFileOutlined from '@material-ui/icons/InsertDriveFileOutlined';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import AccountCircleOutlined from '@material-ui/icons/AccountCircleOutlined';
import Close from '@material-ui/icons/Close';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import { changeDrawerState } from '../../../redux/actions/drawerActions'
import { signOut } from '../../../redux/actions/authActions'
import { Button } from '@material-ui/core';

const styles = theme => ({
  flexMenuWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  }
});

class DrawerLandingMobile extends React.PureComponent {

  toggleDrawer = () => {
    this.props.dispatch(changeDrawerState());
  }

  handleSignOut = () => {
    localForage.removeItem('auth').then(() => {
      this.props.dispatch(signOut());
      this.props.dispatch(changeDrawerState());
      window.location = '/auth/login';
    });
  }

  handleLinkTo = link => event => {

    if (link.match(/^https/ig)) {
      window.open(link, '_blank');
    }

    this.props.dispatch(changeDrawerState());
    this.props.history.push(link);
  }

  render() {
    const { classes } = this.props;

    return (
      <SwipeableDrawer 
        disableBackdropTransition
        open={this.props.drawerOpened}
        onClose={this.toggleDrawer}
        onOpen={this.toggleDrawer}
      >
        <div
          tabIndex={0}
          role="button"
          className={classes.flexMenuWrapper}
        >
          <div style={{display: 'flex', flexGrow: 1, width: '100%', justifyContent: 'flex-end', padding: 20}}>
            <IconButton onClick={this.toggleDrawer}>
              <Close />
            </IconButton>
          </div>
          <div style={{width: 250, flexGrow: 2, display: 'flex', alignItems: 'flex-start'}}>
            <List style={{width: '100%'}}>
              <div>
                <ListItem button onClick={this.handleLinkTo('/how-it-works')}>
                  <ListItemIcon>
                    <AccountCircleOutlined />
                  </ListItemIcon>
                  <ListItemText primary="¿Cómo participar?" />
                </ListItem>
                <Divider light />
                <ListItem button component={'a'} href="https://cosmocare.eu/contact" target="_blank">
                  <ListItemIcon>
                    <InsertDriveFileOutlined />
                  </ListItemIcon>
                  <ListItemText primary="Contacto" />
                </ListItem>
                <Divider light />
                <ListItem button onClick={this.handleLinkTo('/auth/login')} >
                  <ListItemIcon>
                    <DescriptionOutlined />
                  </ListItemIcon>
                  <ListItemText primary="Iniciar sesión"/>
                </ListItem>
              </div>
            </List>
          </div>
        </div>
      </SwipeableDrawer>
    )
  }
}

export default withRouter(
  connect(state => ({
    drawerOpened: state.drawer.open
  }))(withStyles(styles)(DrawerLandingMobile))
)


// WEBPACK FOOTER //
// ./src/modules/shared/components/DrawerLandingMobile.js